/**
 * This is a wrapper component for different Layouts. Footer content should be added to this wrapper.
 */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './LayoutWrapperFooter.module.css';

const LayoutWrapperFooter = ({
  className = '',
  rootClassName = '',
  children,
}) => {
  const classes = classNames(rootClassName || css.root, className);

  return <div className={classes}>{children}</div>;
};

LayoutWrapperFooter.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  rootClassName: PropTypes.string,
};

export default LayoutWrapperFooter;
